import { FormStepType } from "../types";
import {
  docType,
  passportLostType,
  firstName,
  lastName,
  documentNumber,
  issuanceDate,
} from "./fields/passport-details-fields";
import { travelPlansGroup } from "./fields/travel-plans-fields";

export const passport_details_lost_stolen: FormStepType = {
  id: 3,
  name: "passport-details",
  title: "3. Passport Details",
  groups: [
    {
      name: "issued-documents",
      fields: [docType({ form: "lost-stolen-passport" })],
      subGroups: [
        {
          name: "passport-book",
          title: "U.S Passport Book",
          subTitle: "Your name as printed on your most recent U.S. Passport book",
          condition: {
            field: "documentType2",
            values: ["passportbook", "both"],
          },
          fields: [
            passportLostType({}),
            issuanceDate({ optional: true }),
            firstName({ optional: true }),
            lastName({ optional: true }),
            documentNumber({ optional: true }),
          ],
          cols: 6,
        },
        {
          name: "passport-card",
          title: "U.S Passport Card",
          subTitle: "Your name as printed on your most recent U.S. Passport card",
          condition: {
            field: "documentType2",
            values: ["passportcard", "both"],
          },
          fields: [
            passportLostType({ type: "card" }),
            issuanceDate({ type: "card", optional: true }),
            firstName({ type: "card", optional: true }),
            lastName({ type: "card", optional: true }),
            documentNumber({ type: "card", optional: true }),
          ],
          cols: 6,
        },
      ],
    },
    travelPlansGroup,
  ],
};
